import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { usePersona } from '@belong/common';
import { Button, IdentityVerificationBanner } from '@belong/ui';
import Spinner from 'components/Spinner/Spinner';
import Space from 'corecomponents/Space/Space';
import { useUserIdentityVerification } from 'hooks/useUserIdentityVerification';
import FormLayout from 'layouts/FormLayout/FormLayout';
import { selectUser } from 'store/redux/user/selectors';
import { RESIDENT_ONBOARDING_STRINGS } from 'strings/resident-onboarding.strings';
import { getResidentOnboardingStepPath, STEPS_DATA } from '../common';

const ROS = RESIDENT_ONBOARDING_STRINGS;

function IdentityCheck() {
  const history = useHistory();
  const { user } = useSelector((state) => ({
    user: selectUser(state),
  }));

  // `selectUser` returns `null` when signed out; this read was already
  // unconditional, so the assertion keeps that throw.
  const {
    hasFetchedIdentityVerification,
    isLoadingIdentityVerification,
    identityVerification,
    refetchIdentityVerification,
  } = useUserIdentityVerification(user!.id, true);

  const {
    isLoadingPersona,
    isVerifying,
    isWaitingSafeDelay,
    startVerification,
  } = usePersona({
    onScriptLoadError: () => {
      // TODO: Handle Error
    },
  });

  function onVerifyPress() {
    startVerification({
      inquiryId: identityVerification?.providerVerificationId,
      sessionToken: identityVerification?.sessionToken,
      onComplete: () => refetchIdentityVerification(),
    });
  }

  function onDonePress() {
    history.push(getResidentOnboardingStepPath(STEPS_DATA.SUCCESS_PAGE));
  }

  const isCompleted =
    identityVerification?.status === 'Passed' ||
    identityVerification?.status === 'RequiresManualReview';

  const buttonText = isCompleted
    ? ROS.identity_verification.done_button
    : ROS.identity_verification.verify_button;
  const buttonCallback = isCompleted ? onDonePress : onVerifyPress;

  const isLoading =
    !hasFetchedIdentityVerification ||
    isLoadingIdentityVerification ||
    isLoadingPersona ||
    isVerifying ||
    isWaitingSafeDelay;

  return (
    <FormLayout>
      <FormLayout.FormLayoutHeader
        title={ROS.identity_verification.title}
        subtitle={ROS.identity_verification.subTitle}
      />
      {isLoading && <Spinner />}
      <IdentityVerificationBanner
        verificationStatus={identityVerification?.status}
      />
      <div className="flex justify-center">
        <Button
          onClick={buttonCallback}
          size={{ _: 'fluid', md: 'default' }}
          className="mt-xl"
        >
          {buttonText}
        </Button>
      </div>
      <Space value="2xl" />
    </FormLayout>
  );
}
export default IdentityCheck;
